<template>
	<div style="width:100%;height:100%;" ref="pie">

	</div>
</template>

<script>
	import echarts from 'echarts'

	function setOption(data) {
		var option = {
			backgroundColor: '#fff',
			title: {
				show:true,
        		z:5,
				subtext: data.title,
				x:'47%',
        		textAlign:'center',
				padding:5,
				y: '45%',
				textStyle:{
					fontSize:12,
					color:'#32b6d3',
					fontWeight:'normal',
					fontFamily:'Microsoft YaHei'
				},
        		subtextStyle:{
          			fontSize:15,
					color:'#566c77',
					fontWeight:'normal',
					fontFamily: 'Microsoft YaHei'
        		}
			},			
			tooltip: {
				show: true,
				confine:true,
				trigger: 'item',
				formatter: "{b}: {c} ({d}%)"
			},
            legend:{
				show: false
            },			
			series: [{
	            type:'pie',
	            selectedMode: 'false',
				selectedOffset:5,
                silent: true,
	            radius: ['50%', '75%'],
				center : ['50%','50%'],
	            color:['#CCCCCC'],
	            label: {
	                normal: {
	                    position: 'center',
	                    formatter: '{c}',
	                    textStyle: {
							color: '#0a97b0',
							fontSize: 14,
							fontWeight:'bold',
							fontFamily: 'Microsoft YaHei'
						},
	                }
	            },
	            itemStyle:{
	            	normal:{
							color:'rgba(0,0,0,0.05)'
						}
	            },
	            data:[
	                {value:data.total}
	            ]
	        },{
				
				type: 'pie',
				selectedMode: 'single',
				selectedOffset:5,
				radius: ['50%', '75%'],
				center : ['50%','50%'],
			//	color: ["#e07072","#f7b84f","#faf896","#7de7fa"],
				color: ["#eb3600","#f7b84f","#33ffcc","#33ccff"],
				label: {
                   normal: {
					   
						show:false,
						position: 'inner',
						// formatter: '{d}%',
						formatter: function(params){
							if(params.value == 0){
								return "";
							}
							return params.value;
						},
						textStyle: {
							color: '#57617B',
							fontSize: 8,
							fontFamily: 'Microsoft YaHei',
							align:'center'
						}
					}
				},
				itemStyle:{
	            	normal:{
							shadowBlur:'8',
					//		borderColor:'#32b6d3',
							shadowColor:'#33ffff',
							borderWidth:'5'
						}
	            },
				labelLine: {
					normal: {
						show: false
					}
				},
				data: data.data
			}]
		};
		return option
	}
	export default {
		name: 'WsPie',
		props: ['args'],
		methods: {
			initChart() {
				window.addEventListener('resize', function() {
					this.myChart.resize()
				}.bind(this))
			},
			resize: function() {
				this.myChart.resize()
			},
			reDrawChart: function(args) {
				this.myChart.setOption(setOption(args), false);
			}
		},
		mounted: function(el) {
			var container = this.$el;
			this.initChart();
			this.myChart = echarts.init(container);
			let _this = this;
			this.myChart.on('click',function(param){
				_this.$emit('pieClick', param);
			});
		},
		watch: {
			updateFlag: function(val) {
				setTimeout(() => {
					this.myChart.resize()
				}, 150);
			}
		}
	}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/echarts/wsPie.vue